import Login from '../views/authentication/login';
import Register from '../views/authentication/register';

var authRoutes = [
    { path: '/authentication/login', name: 'Login', icon: 'mdi mdi-account-key', component: Login },
    { path: '/authentication/register', name: 'Register', icon: 'mdi mdi-account-plus', component: Register }
];
export default authRoutes;
